// extracted by mini-css-extract-plugin
export default {"container":"page-top-bar-module__container--UvIAA"};